export default __webpack_public_path__ + "static/media/payment-success-light.6cff9d22.png";